export default {
  title: 'Tijdupdate!',
  labels: {
    old_time: 'Vorige afhaaltijd:',
    new_time: 'Nieuwe afhaaltijd:',
    old_serve_time: 'Vorige serveertijd:',
    new_serve_time: 'Nieuwe serveertijd:',
  },
  buttons: {
    print: 'Afdrukken & sluiten',
    got_it: 'Begrepen',
  },
  feedback: {
    new_prep_time: 'De bezorgtijd is bijgewerkt. Pas je bereidingsschema hierop aan.',
  },
  toasts: {
    something_went_wrong: 'Er is iets misgegaan, probeer het opnieuw',
  },
};
